import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  ViewEncapsulation,
} from '@angular/core';


@Component({
  selector: 'shared-form-header',
  standalone: true,
  imports: [],
  templateUrl: './form-header.component.html',
  styleUrl: './form-header.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormHeaderComponent {
  formTitle: InputSignal<string> = input.required();
}
